module.exports = __webpack_public_path__ + "img/logo.be9def73.png";